import { ResourceCentrePageCategoryItem } from '../../../types';

export const translations: ResourceCentrePageCategoryItem = {
  title: 'Cartes de crédit et de débit',
  content: [
    'La perte de vos cartes de paiement peut être stressante et incommodante, vous laissant sans accès à des fonds et',
    'vulnérable à la fraude. Voici quelques mesures que vous pouvez prendre immédiatement pour surmonter la perte de',
    'vos cartes de paiement et vous remettre sur la bonne voie :',

    '<ul>',

    '<li><strong>Signaler immédiatement la perte ou le vol de cartes bancaires</strong><br />',
    'Signalez le vol ou la perte de vos cartes de débit ou de crédit dès que vous vous en rendez compte afin d’éviter toute dépense non autorisée. Les utilisateurs d’EnGarde peuvent rapidement annuler leurs cartes de débit ou de crédit perdues ou volées en ligne ou simplement en appelant un représentant du service clientèle.',
    '</li>',

    '<li><strong>Mettre à jour les paiements préautorisés</strong><br />',
    'Les paiements préautorisés à partir de votre compte bancaire (comme le loyer et les factures de services publics)',
    'ne devraient pas être concernés. Les paiements préautorisés portés à vos cartes (les paiements récurrents pour',
    'des services comme Netflix apparaissant sur vos relevés mensuels) ne sont pas automatiquement transférés sur de',
    'nouvelles cartes. Contactez ces services pour mettre à jour vos informations de facturation afin de vous assurer',
    'la continuité du service.',
    '</li>',

    '<li><strong>Mettre à jour les informations sur le paiement enregistrées en ligne</strong><br />',
    'Mettez à jour vos informations sur le paiement sur tous les sites où elles peuvent être enregistrées, comme',
    'Amazon ou Apple Pay, afin de pouvoir continuer à effectuer des achats sans encombre.',
    '</li>',

    '</ul>'
  ].join('\n')
};
